<div class="fab" [class.fab_close]="isToggled">
  <div class="fab__counter" *ngIf="counter">{{ counter }}</div>
  <app-icon class="fab__icon" [icon]="isToggled ? 'close-fab' : icon"></app-icon>
</div>
